const { api, providesList } = require('api');

const taskAPI = api.enhanceEndpoints({ addTagTypes: ['Task'] }).injectEndpoints({
  endpoints: (build) => ({
    getTask: build.query({
      query: ({ taskId }) => `/tasks/${taskId}`,
      providesTags: (result, error, args) => (result ? [{ type: 'Task', id: result?.id }] : []),
      transformResponse: (response) => response.data,
    }),
    getAllTasks: build.query({
      query: () => `/tasks?include=dependencies,area,company`,
      providesTags: (result, error, args) => (result ? providesList(result, 'Task') : []),
      transformResponse: (response) => response.data,
    }),
    getTasksByProject: build.query({
      query: ({ projectId }) => `/tasks?project=${projectId}&include=dependencies,area,company`,
      providesTags: (result, error, args) => (result ? providesList(result, 'Task') : []),
      transformResponse: (response) => response.data,
    }),
  }),
});

export const { useGetTaskQuery, useGetAllTasksQuery, useGetTasksByProjectQuery } = taskAPI;
